import { GetAsientoContableByIdDtoProps } from "./DTOs/GetAsientoContableByIdDto"
import { GetImportesLineasAsientosContablesDto } from "./DTOs/GetImportesLineasAsientosContablesDto"
import { GetModelo111ResumenImpuestosDtoProps } from "./DTOs/GetModelo111ResumenImpuestosDto"
import { GetModelo115ResumenImpuestosDtoProps } from "./DTOs/GetModelo115ResumenImpuestosDto"
import { GetModelo180DetalleImpuestosDto } from "./DTOs/GetModelo180DetalleImpuestosDto"
import { GetModelo180DtoProps } from "./DTOs/GetModelo180Dto"
import { GetModelo190DetalleImpuestosDto } from "./DTOs/GetModelo190DetalleImpuestosDto"
import { GetModelo190DtoProps } from "./DTOs/GetModelo190Dto"
import { GetModelo303ResumenImpuestosDtoProps } from "./DTOs/GetModelo303ResumenImpuestosDto"
import { GetModelo347DetalleImpuestosDto } from "./DTOs/GetModelo347DetalleImpuestosDto"
import { GetModelo347DtoProps } from "./DTOs/GetModelo347Dto"
import { GetModelo349ResumenImpuestosDtoProps } from "./DTOs/GetModelo349ResumenImpuestosDto"
import { GetModelo390ResumenImpuestosDtoProps } from "./DTOs/GetModelo390ResumenImpuestosDto"
import { GetModeloDetalleImpuestosAsientosContablesDtoBaseProps } from "./DTOs/GetModeloDetalleImpuestosAsientosContablesDtoBase"
import { LineasAsientosContablesByFilterDtoIProps } from "./DTOs/LineasAsientosContablesByFilterDto"
import { PeriodoGetModelo111DtoProps } from "./DTOs/PeriodoGetModelo111Dto"
import { PeriodoGetModelo115DtoProps } from "./DTOs/PeriodoGetModelo115Dto"
import { PeriodoGetModelo303DtoProps } from "./DTOs/PeriodoGetModelo303Dto"
import { PeriodoGetModelo349DtoProps } from "./DTOs/PeriodoGetModelo349Dto"
import { PeriodoGetModelo390DtoProps } from "./DTOs/PeriodoGetModelo390Dto"
import { ResumenGetModelo111ResumenImpuestoDtoProps } from "./DTOs/ResumenGetModelo111ResumenImpuestoDto"
import { ResumenGetModelo115ResumenImpuestoDtoProps } from "./DTOs/ResumenGetModelo115ResumenImpuestosDto"
import { ResumenGetModelo303ResumenImpuestoDtoProps } from "./DTOs/ResumenGetModelo303ResumenImpuestosDto"

export const asientoDiarioByFilterAdapter = (
  asiento: LineasAsientosContablesByFilterDtoIProps
): LineasAsientosContablesByFilterDtoIProps => {
  return {
    id: asiento.id,
    asientoContable: asiento.asientoContable,
    tipo: asiento.tipo,
    cuentaContable: asiento.cuentaContable,
    descripcion: asiento.descripcion,
    importe: asiento.importe,
    numero: asiento.numero,
    numeroDocumento: asiento.numeroDocumento,
    saldo: asiento.saldo,
    listadoTags: asiento.listadoTags,
  }
}

export const ResumentImpuestoIvaDetalleAdapter = (
  data: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps
): GetModeloDetalleImpuestosAsientosContablesDtoBaseProps => ({
  asiento: {
    id: data?.asiento?.id,
    fecha: data?.asiento?.fecha,
    numero: data?.asiento?.numero,
    lineaImpuesto: data?.asiento?.lineaImpuesto,
  },
  factura: {
    id: data?.factura?.id,
    numero: data?.factura?.numero,
    empresa: {
      razonSocial: data?.factura?.empresa?.razonSocial,
      nif: data?.factura?.empresa?.nif,
    },
    fechaEmision: data?.factura?.fechaEmision,
    importe: data?.factura?.importe,
    retencion: data?.factura?.retencion,
  },
})

export const ResumentImpuestoIvaDetalle180Adapter = (
  data: GetModelo180DetalleImpuestosDto
): GetModelo180DetalleImpuestosDto => ({
  baseImponible: data?.baseImponible,
  nif: data?.nif,
  nombre: data?.nombre,
  provincia: data?.provincia,
  totalRetencion: data?.totalRetencion,
})

export const ResumentImpuestoIvaDetalle190Adapter = (
  data: GetModelo190DetalleImpuestosDto
): GetModelo190DetalleImpuestosDto => ({
  baseImponible: data?.baseImponible,
  clave: data?.clave,
  nif: data?.nif,
  nombre: data?.nombre,
  provincia: data?.provincia,
  subclave: data?.subclave,
  totalRetencion: data?.totalRetencion,
})

export const ResumentImpuestoIvaDetalle347Adapter = (
  data: GetModelo347DetalleImpuestosDto
): GetModelo347DetalleImpuestosDto => ({
  clave: data?.clave,
  cuartoTrimestre: data?.cuartoTrimestre,
  email: data?.email,
  isp: data?.isp,
  nif: data?.nif,
  nombre: data?.nombre,
  primerTrimestre: data?.primerTrimestre,
  provincia: data?.provincia,
  segundoTrimestre: data?.segundoTrimestre,
  tercerTrimestre: data?.tercerTrimestre,
  total: data?.total,
})

const ResumenImpuestoAdapter = (
  data:
    | ResumenGetModelo111ResumenImpuestoDtoProps
    | ResumenGetModelo115ResumenImpuestoDtoProps
) => ({
  importe: data.importe,
  porcentajeImpuesto: data.porcentajeImpuesto,
  subtotal: data.subtotal,
})

const ResumenImpuestoWithNombreAdapter = (
  data: ResumenGetModelo303ResumenImpuestoDtoProps
) => ({
  importe: data.importe,
  nombre: data.nombre,
  porcentajeImpuesto: data.porcentajeImpuesto,
  subtotal: data.subtotal,
})

export const ResumentImpuesto303and390Adapter = (
  data:
    | GetModelo303ResumenImpuestosDtoProps
    | GetModelo390ResumenImpuestosDtoProps
) => {
  return {
    compras: data.compras?.map((compra) =>
      ResumenImpuestoWithNombreAdapter(compra)
    ),
    ventas: data.ventas?.map((venta) =>
      ResumenImpuestoWithNombreAdapter(venta)
    ),
  }
}

export const ResumenImpuesto349Adapter = (
  data: GetModelo349ResumenImpuestosDtoProps
) => {
  return {
    compras: data.compras?.map((compra) =>
      ResumenImpuestoWithNombreAdapter(compra)
    ),
  }
}

export const ResumenImpuestoOtrosAdapter = (
  data:
    | GetModelo111ResumenImpuestosDtoProps
    | GetModelo115ResumenImpuestosDtoProps
) => {
  return {
    compras: data.compras?.map((compra) => ResumenImpuestoAdapter(compra)),
  }
}

export const AsientoContableModelo303Adapter = (
  periodo: PeriodoGetModelo303DtoProps
) => ({
  asientoContableLiquidacionId: periodo?.asientoContableLiquidacionId,
  periodo: periodo?.periodo,
  repercutido: periodo?.repercutido,
  soportado: periodo?.soportado,
  totalIva: periodo?.totalIva,
})

export const AsientoContableModelo390Adapter = (
  periodo: PeriodoGetModelo390DtoProps
) => ({
  asientoContableLiquidacionId: periodo?.asientoContableLiquidacionId,
  periodo: periodo?.periodo,
  repercutido: periodo?.repercutido,
  soportado: periodo?.soportado,
  totalIva: periodo?.totalIva,
})

export const AsientoContableModelo115Adapter = (
  periodo: PeriodoGetModelo115DtoProps
) => ({
  importe: periodo?.importe,
  periodo: periodo?.periodo,
})

export const AsientoContableModelo111Adapter = (
  periodo: PeriodoGetModelo111DtoProps
): PeriodoGetModelo111DtoProps => ({
  periodo: periodo?.periodo,
  totalPercepcion: periodo?.totalPercepcion,
  totalPerceptores: periodo?.totalPerceptores,
  totalRetencion: periodo?.totalRetencion,
})

export const AsientoContableModelo180Adapter = (
  data: GetModelo180DtoProps
): GetModelo180DtoProps => ({
  totalPercepcion: data?.totalPercepcion,
  totalPerceptores: data?.totalPerceptores,
  totalRetencion: data?.totalRetencion,
})

export const AsientoContableModelo190Adapter = (
  data: GetModelo190DtoProps
): GetModelo190DtoProps => ({
  totalPercepcion: data?.totalPercepcion,
  totalPerceptores: data?.totalPerceptores,
  totalRetencion: data?.totalRetencion,
})

export const AsientoContableModelo347Adapter = (
  data: GetModelo347DtoProps
): GetModelo347DtoProps => ({
  totalInmuebles: data?.totalInmuebles,
  totalOperaciones: data?.totalOperaciones,
  totalOperacionesArrendamientoLocalesNegocio:
    data?.totalOperacionesArrendamientoLocalesNegocio,
  totalPersonasEntidades: data?.totalPersonasEntidades,
})

export const AsientoContableModelo349Adapter = (
  periodo: PeriodoGetModelo349DtoProps
) => ({
  baseImponible: periodo?.baseImponible,
  iva: periodo?.iva,
  periodo: periodo?.periodo,
})

export const ImportesTotalesAsientoContableAdapter = (
  data: GetImportesLineasAsientosContablesDto
) => ({
  debeTotal: data?.debeTotal,
  haberTotal: data?.haberTotal,
  saldoAcumulado: data?.saldoAcumulado,
  saldoPeriodo: data?.saldoPeriodo,
})

export const asientoByIdAdapter = (
  asiento: GetAsientoContableByIdDtoProps
): GetAsientoContableByIdDtoProps => ({
  id: asiento.id,
  fecha: asiento.fecha,
  ficheros: asiento.ficheros,
  lineas: asiento.lineas,
  lineasImpuesto: asiento.lineasImpuesto,
  notas: asiento.notas,
  numero: asiento.numero,
  tipoAsiento: asiento.tipoAsiento,
  tipoImportacionAsiento: asiento.tipoImportacionAsiento,
})
